import { HLabel } from 'components/HLabel'
import React from 'react'

import { EncaminhamentoExternoLotacao } from '../model'

type EncaminhamentoExternoLotacaoProps = EncaminhamentoExternoLotacao

export function EncaminhamentoExternoDetalheLotacao({ nome, cbo }: Readonly<EncaminhamentoExternoLotacaoProps>) {
  return (
    <HLabel title='Encaminhado por:'>
      {nome.titleCase()} - {cbo}
    </HLabel>
  )
}
